import { useEffect, useState } from 'react'
import throttle from 'helpers/throttle'
import useLatest from 'hooks/useLatest'

function useDocumentScrollThrottled(callback) {
  const hasWindow = typeof window !== 'undefined' && window
  const [, setScrollPosition] = useState(0)
  const callbackRef = useLatest(callback)

  useEffect(() => {
    let previousScrollTop = 0

    function handleDocumentScroll() {
      const { scrollTop: currentScrollTop } =
        document.documentElement || document.body

      setScrollPosition((previousPosition) => {
        previousScrollTop = previousPosition
        return currentScrollTop
      })

      // callback is read via ref rather than being a dependency -- it's a
      // new function reference on every render of the caller, and this
      // effect needs a stable throttled listener across renders so the
      // 250ms throttle window isn't reset on every render.
      callbackRef.current({ previousScrollTop, currentScrollTop })
    }

    const handleDocumentScrollThrottled = throttle(handleDocumentScroll, 250)

    hasWindow &&
      window.addEventListener('scroll', handleDocumentScrollThrottled)

    return () =>
      hasWindow &&
      window.removeEventListener('scroll', handleDocumentScrollThrottled)
  }, [hasWindow, callbackRef])
}

export default useDocumentScrollThrottled
